import { render } from "./OpportunitiesMain.vue?vue&type=template&id=1172d785&scoped=true&lang=true"
import script from "./OpportunitiesMain.vue?vue&type=script&lang=js"
export * from "./OpportunitiesMain.vue?vue&type=script&lang=js"

import "./OpportunitiesMain.vue?vue&type=style&index=0&id=1172d785&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-1172d785"

export default script